(() => {
  angular
    .module('complianceFrameworkApp.complianceServices')
    .directive('contentSearch', contentSearch);

  /* ngInject */
  function contentSearch($state, config, sessionService) {
    let directive = {
      restrict: 'E',
      templateUrl: '/templates/compliance_services/components/content-search.directive.html',
      link: link
    };

    return directive;

    function link(scope, _element, _attrs) {
      scope.search = search;

      initializeTypeahead();
    }

    function initializeTypeahead() {
      let topics = new Bloodhound({
        datumTokenizer: datum => Bloodhound.tokenizers.whitespace(datum.name),
        queryTokenizer: Bloodhound.tokenizers.whitespace,
        prefetch: {
          url: `${config.complianceServicesApiEndpoint}/api/topics/search`,
          prepare: function(settings) {
            settings.headers = {
              'Authorization': `Token token=${sessionService.getAuthToken()}`
            };
            return settings;
          }
        }
      });

      // Initialize typeahead
      angular.element('#compliance-search .typeahead').typeahead({
        hint: true,
        highlight: true,
        minLength: 1
      }, {
        name: 'value',
        display: 'name',
        source: topics,
        templates :{
          empty: `<div class='no-results-found'>No Topics Found</div>`,
          suggestion: topic => `<div class='tt-suggestion text-left'><span class='glyphicons glyphicons-education'></span> <strong>${topic.name}</strong><br /><small class='text-muted'>${$.map(topic.categories, category => category.name).join(', ')}</small></div>`
        }
      });

      // Selecting a suggestion navigates to the topic
      angular.element('#compliance-search .typeahead').bind('typeahead:select', function(ev, topic) {
        $state.go('application.compliance_services.topic', {id: topic.id});
      });
    }

    function search() {
      // Using selector here due to conflicts with typeahead and ng-model
      let query = angular.element('#search-query').val();
      $state.go('application.compliance_services.search', {query: query});
    }
  }
})();
